@if (userProfile$ | async; as user) {
  <div class="profile-details">
    <div class="card profile-details__avatar mb-4 border-0">
      <div class="card-body">
        <div class="row align-items-center flex-nowrap">
          <div class="col-auto">
            <app-avatar
              [firstName]="user.first_name"
              [lastName]="user.last_name"
              size="xl"></app-avatar>
          </div>
          <div class="col">
            <span class="h1 mb-0">{{ user.first_name }} {{ user.last_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<div
  class="card card-info card-settings card-collapse-arrow"
  [ngClass]="{ 'collapsed': isProfileCollapsed }">
  <app-info-card-header
    (click)="onOpenProfile()"
    id="onOpenProfile"
    (keydown)="onOpenProfile()"
    [attr.aria-expanded]="!isProfileCollapsed"
    aria-controls="collapseProfile"
    iconClass="iconoir-user"
    [showCollapse]="true"
    title="Profile details"></app-info-card-header>
  <div
    #profileCollapse="ngbCollapse"
    [(ngbCollapse)]="isProfileCollapsed">
    <div class="card-body">
      <app-profile />
    </div>
  </div>
</div>

<div
  class="card card-info card-settings card-collapse-arrow"
  [ngClass]="{ 'collapsed': isBusinessCollapsed }">
  <app-info-card-header
    (click)="onOpenBusiness()"
    id="onOpenBusiness"
    (keydown)="onOpenBusiness()"
    [attr.aria-expanded]="!isBusinessCollapsed"
    aria-controls="collapseBusiness"
    iconClass="iconoir-city"
    [showCollapse]="true"
    title="Business details"></app-info-card-header>
  <div
    #businessCollapse="ngbCollapse"
    [(ngbCollapse)]="isBusinessCollapsed">
    <div class="card-body">
      <app-business-details />
    </div>
  </div>
</div>

<div
  class="card card-info card-settings card-collapse-arrow"
  [ngClass]="{ 'collapsed': isBusinessCollapsed }">
  <app-info-card-header
    (click)="onOpenBanking()"
    id="onOpenBanking"
    (keydown)="onOpenBanking()"
    [attr.aria-expanded]="!isBankingCollapsed"
    aria-controls="collapseBanking"
    iconClass="iconoir-credit-card"
    [showCollapse]="true"
    [showStatus]="bankStatus === bankingStatus.New || bankStatus === bankingStatus.Reviewed"
    statusIcon="iconoir-info-circle"
    statusColor="warning"
    statusTitle="Pending review"
    title="Banking details">
  </app-info-card-header>
  <div
    #bankingCollapse="ngbCollapse"
    [(ngbCollapse)]="isBankingCollapsed">
    <div class="card-body">
      <app-banking-details-body [bankingDetails]="bankingDetails()"></app-banking-details-body>
    </div>
  </div>
</div>

<div id="offCanvasGhostContainer">
  <router-outlet></router-outlet>
</div>
